import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%; 
`

export const Wrapper = styled.div`
  margin-top: 20px;
`
